import { colorSchemes } from "../config/colorSchemes";

export const deploymentStatusRenderer = (
  _instance,
  td,
  _row,
  _col,
  prop,
  value,
) => {
  if (!prop || !value) {
    td.innerHTML = `<div class="trucnated"></div>`;
    return td;
  }

  const color = colorSchemes[prop][value.name] ?? [];

  td.style.backgroundColor = color[0];
  td.style.color = color[1];
  td.innerHTML = `<div class="truncated">${value.name}</div>`;
  return td;
};
